import { XStack, YStack, type YStackProps } from 'tamagui';

export interface SkeletonProps extends YStackProps {
  width?: number | string;
  height?: number | string;
}

export function Skeleton({ width, height = 14, ...rest }: SkeletonProps) {
  return (
    <YStack
      backgroundColor="$color6"
      borderRadius="$2"
      width={width}
      height={height}
      {...rest}
    />
  );
}

export function SkeletonText({ width = '80%' }: { width?: number | string }) {
  return <Skeleton width={width} height={14} />;
}

export function SkeletonList({ count = 5 }: { count?: number }) {
  return (
    <YStack gap="$3">
      {Array.from({ length: count }, (_, i) => (
        <XStack key={i} gap="$3" alignItems="center" role="presentation">
          <Skeleton width={20} height={20} borderRadius="$1" />
          <YStack flex={1} gap="$2">
            <SkeletonText width="70%" />
            <SkeletonText width="40%" />
          </YStack>
        </XStack>
      ))}
    </YStack>
  );
}
